declare var notie: any;
declare var Noty: any;
declare var Swal: any;
declare var bootstrap: any;

// moved GlobalThis declarations to `src/ts/global.d.ts` to avoid emitting ES module exports

/*=============================================*
Validación desde Bootstrap 5
=============================================*/

(function () {
	'use strict'

	// Fetch all the forms we want to apply custom Bootstrap validation styles to
	var forms = document.querySelectorAll('.needs-validation')

	// Loop over them and prevent submission
	Array.prototype.slice.call(forms)
		.forEach(function (form: HTMLFormElement) {
			form.addEventListener('submit', function (event: Event) {
				if (!form.checkValidity()) {
					event.preventDefault()
					event.stopPropagation()
				}

				form.classList.add('was-validated')
			}, false)
		})
})()

if (localStorage.getItem("kt_auth_lang")) {

} else {
	localStorage.setItem("kt_auth_lang", "Spanish")

}


/*=============================================*
Función para Notie Alert
=============================================*/

function fncNotie(type: number, text: string) {

	notie.alert({

		type: type,
		text: text,
		time: 5

	})

}

function fncNoty(type: string, text: string) {

	let n = new Noty({
		theme: 'nest',
		layout: 'topRight',
		text: text,
		type: type,
	});
	n.show()
	n.setTimeout(2500)
}

/*=============================================*
Función Sweetalert
=============================================*/
function fncSweetAlertToast(type: 'success' | 'error' | 'warning' | 'info' | 'question', text: string) {

	/*=============================================*
			Cuando ocurre un error
			=============================================*/
	const Toast = Swal.mixin({
		toast: true,
		position: 'top',
		showConfirmButton: false,
		timer: '3000',
		timerProgressBar: true,
		didOpen: (toast: any) => {
			toast.addEventListener('click', Swal.close)
			toast.addEventListener('mouseleave', Swal.resumeTimer)
		}
	})


	Toast.fire({
		icon: type,
		title: text,
		showClass: {
			pup: 'animate__animated animate__tada'
		},
		hideClass: {
			pup: 'animate__animated animate__zoomOut'
		}
	})


}
function fncSweetAlert(type: string, text: string, url?: string) {

	switch (type) {

		/*=============================================*
	Cuando ocurre un warning
	=============================================*/

		case "warning":

			if (url == null) {

				Swal.fire({
					icon: 'warning',
					title: 'warning',
					text: text
				})

			} else {

				Swal.fire({
					icon: 'warning',
					title: 'warning',
					text: text
				}).then((result: any) => {

					if (result.value) {

						window.open(url, "_top");

					}

				})

			}

			break;

		/*=============================================*
		Cuando ocurre un error
		=============================================*/

		case "error":

			if (url == null) {

				Swal.fire({
					icon: 'error',
					title: 'Error',
					text: text
				})

			} else {

				Swal.fire({
					icon: 'error',
					title: 'Error',
					text: text
				}).then((result: any) => {

					if (result.value) {

						window.open(url, "_top");

					}

				})

			}

			break;

		/*=============================================*
 Cuando es correcto
 =============================================*/

		case "success":

			if (url == null) {

				Swal.fire({
					icon: 'success',
					title: 'Success',
					text: text
				})

			} else {

				Swal.fire({
					icon: 'success',
					title: 'Success',
					text: text
				}).then((result: any) => {

					if (result.value) {

						window.open(url, "_top");

					}

				})

			}

			break;

		/*=============================================*
Cuando estamos precargando
=============================================*/

		case "loading":

			Swal.fire({
				allowOutsideClick: false,
				icon: 'info',
				text: text
			})
			Swal.showLoading()

			break;

		/*=============================================*
Cuando necesitamos cerrar la alerta suave
=============================================*/

		case "close":

			Swal.close()

			break;

		/*=============================================*
	 Cuando solicitamos confirmación
	 =============================================*/

		case "confirm":

			return new Promise(resolve => {

				Swal.fire({
					text: text,
					icon: 'question',
					showCancelButton: true,
					confirmButtonColor: '#7066e0',
					cancelButtonColor: '#dd3333e3',
					cancelButtonText: 'Cancelar',
					confirmButtonText: 'Eliminar'
				}).then(function (result: any) {

					resolve(result.value);

				})

			})

			break;

		/*=============================================*
		Cuando necesitamos alerta con timer
		=============================================*/

		case "alert":

			Swal.fire({
				icon: url,
				title: text,
				showConfirmButton: false,
				timer: 3500,
				timerProgressBar: true,
				allowOutsideClick: false,
				allowEscapeKey: false,
				color: '#716add',
				background: '#fff',
				backdrop: 'rgba(0,0,123,0.4) left top no-repeat'
			})

			break;
	}


}

/*=============================================*
Función Material Preload
=============================================*/

function matPreloader(type: 'on' | 'off') {

	var preloader = new ($.materialPreloader as any)({
		position: 'top',
		height: '5px',
		col_1: '#159756',
		col_2: '#da4733',
		col_3: '#3b78e7',
		col_4: '#fdba2c',
		fadeIn: 200,
		fadeOut: 200
	});

	if (type == "on") {

		preloader.on();

	}

	if (type == "off") {

		$(".load-bar-container").remove();
	}

}

/*=============================================*
Función para validar data repetida
=============================================*/
function validateRepeat(event: Event, type: string) {

	const target = event.target as HTMLInputElement;
	var data = new FormData();
	data.append("data", target.value);
	data.append("table", "users");
	data.append("suffix", "email_user");

	$.ajax({
		url: "ajax/ajax-validate.php",
		method: "POST",
		data: data,
		contentType: false,
		cache: false,
		processData: false,
		success: function (response: any) {

			if (response == 200) {

				$(target).addClass("is-invalid");
				$(target).parent().children(".invalid-feedback").html("El correo ya fue registrado!");
				target.value = "";
			} else {

				validateJS(event, type);

			}

		}

	})


}

/*=============================================*
Función para validar formulario
=============================================*/
function validateJS(event: Event, type: string) {
	const target = event.target as HTMLInputElement;
	/*=============================================*
		Validamos texto
		=============================================*/

	if (type == "text") {
		var pattern = /^[A-Za-zñÑáéíóúÁÉÍÓÚ ]{1,}$/;

		if (!pattern.test(target.value)) {
			$(target).parent().addClass("was-validated");

			$(target)
				.parent()
				.children(".invalid-feedback")
				.html("No use números ni caracteres especiales!");

			// target.value = "";

			return;
		}
	}

	/*=============================================*
		Validamos texto y números
		=============================================*/

	if (type == "text&number") {
		var pattern = /^[0-9A-Za-zñÑáéíóúÁÉÍÓÚ ]{1,}$/;

		if (!pattern.test(target.value)) {
			$(target).parent().addClass("was-validated");

			$(target)
				.parent()
				.children(".invalid-feedback")
				.html("No use caracteres especiales");

			target.value = "";

			return;
		}
	}

	/*=============================================*
		Validamos email
		=============================================*/

	if (type == "email") {
		var pattern =
			/^[^0-9][.a-zA-Z0-9_]+([.][.a-zA-Z0-9_]+)*[@][a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)*[.][a-zA-Z]{2,4}$/;

		if (!pattern.test(target.value)) {
			$(target).parent().addClass("was-validated");

			$(target)
				.parent()
				.children(".invalid-feedback")
				.html("Ingrese un Correo Electrónico valido!");

			// target.value = "";

			return;
		}
	}

	/*=============================================*
		Validamos contraseña
		=============================================*/

	if (type == "password") {
		var pattern = /^[#\\=\\$\\;\\*\\_\\@\\%\\?\\¿\\!\\¡\\°\\&\\(\\)\\;\\.\\,\\0-9a-zA-Z]{1,}$/;

		if (!pattern.test(target.value)) {
			$(target).parent().addClass("was-validated");

			$(target)
				.parent()
				.children(".invalid-feedback")
				.html("La contraseña está mal escrita!");

			target.value = "";

			return;
		}
	}

	/*=============================================*
		Validamos teléfono
		=============================================*/

	if (type == "phone") {
		var pattern = /^[-\\(\\) \\0-9 ]{1,}$/;

		if (!pattern.test(target.value)) {
			$(target).parent().addClass("was-validated");

			$(target)
				.parent()
				.children(".invalid-feedback")
				.html("Ingrese un numero de teléfono valido!");

			target.value = "";

			return;
		}
	}

	/*=============================================*
		Validamos párrafos
		=============================================*/

	if (type == "paragraphs") {
		var pattern =
			/^[-\\(\\) \\=\\%\\&\\$\\;\\_\\°\\"\\*\\"\\#\\?\\¿\\!\\¡\\:\\,\\.\\0-9a-zA-ZñÑáéíóúÁÉÍÓÚ ]{1,}$/;

		if (!pattern.test(target.value)) {
			$(target).parent().addClass("was-validated");

			$(target)
				.parent()
				.children(".invalid-feedback")
				.html("La entrada está mal escrita");

			target.value = "";

			return;
		}
	}

	/*=============================================*
		Validamos número
		=============================================*/

	if (type == "numbers") {
		var pattern = /^[.,\\0-9]{1,}$/;

		if (!pattern.test(target.value)) {
			$(target).parent().addClass("was-validated");

			$(target)
				.parent()
				.children(".invalid-feedback")
				.html("La entrada está mal escrita");

			target.value = "";

			return;
		}
	}
}
/*=============================================*
Validamos imagen
=============================================*/

function validateImageJS(event: Event, input: string) {

	const target = event.target as HTMLInputElement;
	if (!target.files) return;
	const image = target.files[0];

	if (image["type"] !== "image/png" && image["type"] !== "image/jpeg" && image["type"] !== "image/jpeg" && image["type"] !== "image/svg+xml") {

		fncNotie(3, "The image must be in JPG, SVG, PNG or GIF format");
		$("#imgProduct").val("");
		($(".changePicture") as any).src("views/assets/img/template/image.png");

		return;

	}

	else if (image["size"] > 2000000) {

		fncNotie(3, "La imagen no debe pesar más de 2MB");
		$("#imgProduct").val("");
		($(".changePicture") as any).src("views/assets/img/template/image.png");

		return;

	} else {

		var data = new FileReader();
		data.readAsDataURL(image);

		$(data).on("load", function (event: any) {

			var path = event.target.result;

			$("." + input).attr("src", path as string);

		})

	}

}

/*=============================================*
Función para formatear Inputs
=============================================*/

function fncFormatInputs() {

	if (window.history.replaceState) {
		window.history.replaceState(null as any, null as any, window.location.href);
	}

}

$(document).ready(function () {

	var loader = document.createElement('div')
	loader.setAttribute('id', 'pre-loader');
	loader.innerHTML = "<div class='lds-hourglass'></div>";

	// Función de inicio del cargador
	// Función de inicio del cargador
	// Usamos `globalThis` para asegurar acceso al objeto global
	globalThis.start_loader = function () {
		const body = document.querySelector('body');
		if (!document.getElementById('pre-loader') && body) {
			body.appendChild(loader);
			body.style.overflow = "hidden";
		}
	}


	// Función de parada del cargador
	globalThis.end_loader = function () {
		const preLoader = document.getElementById('pre-loader');
		const body = document.querySelector('body');
		if (preLoader && body) {
			setTimeout(() => {
				preLoader.remove();
				body.style.overflow = "";
			}, 500);
		}
	}
	const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
	const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
});
